import { DashBoardInspectionData } from './dash-board-inspection-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class SiteDashBoardScaffoldInspectionData {
  SiteId: string;
  SiteName: string;
  SiteReference: string;
  SiteStatusId: string;
  ScaffoldId: string;
  NextInspectionDate: string;
  CustomerId: string;
  CustomerName: string;
  ContractId: string;
  ContractStatusId: string;
  InspectionData: DashBoardInspectionData[];
}


